<template>
  <div class="py-16 min-h-screen text-center">
    <div class="py-16">
      <router-link :to="{ name: 'Homepage' }">
        <img src="../../assets/img/logo-dark.svg" alt="Fleetbeacon Logo" style="height:40px;" class="mx-auto">
      </router-link>
    </div>
    <h1 class="text-5xl font-bold">
      404
    </h1>
    <div class="text-lg text-gray-500">
      The page you're looking for cannot be found
    </div>
    <div class="text-center py-5">
      <router-link :to="{ name: 'Homepage' }" class="btn btn-primary">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
